import { configureStore } from '@reduxjs/toolkit';
import filtersReducer from './features/filters/filtersSlice';
import doctorsReducer from './features/doctors/doctorsSlice';
import bookingReducer from './features/bookingForm/bookingFormSlice';
import serviceReducer from './serviceBooking/store/serviceSlice';

const middlewares = [];

if (process.env.NODE_ENV === `development`) {
    // eslint-disable-next-line global-require
    const { logger } = require(`redux-logger`);

    middlewares.push(logger);
}

export const createStore = () => configureStore({
    reducer: {
        filters: filtersReducer,
        doctors: doctorsReducer,
        bookingForm: bookingReducer,
        services: serviceReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
        .concat(middlewares),
});

export const store = createStore();
